import { Component } from '@angular/core';
import {
  ISKGenericStaticPageAttributes,
  ISKStaticPages,
  StaticPagesService
} from "../../services/static-pages/static-pages.service";
import {ActivatedRoute} from "@angular/router";
import {BaseView} from "../baseView";

@Component({
  selector: 'sk-static-privacy-policy',
  templateUrl: './sk-static-privacy-policy.component.html',
  styleUrls: ['./sk-static-privacy-policy.component.scss']
})
export class SkStaticPrivacyPolicyComponent extends BaseView {

  private readonly endpoint = this.activatedRoute.snapshot.data['endpoint'];
  public pageData: ISKGenericStaticPageAttributes;

  constructor(
    private readonly staticPagesService: StaticPagesService,
    private readonly activatedRoute: ActivatedRoute
  ) {
    super();
    this.subscriptions.push(this.staticPagesService.staticPageData.subscribe((staticPages: ISKStaticPages) => {
      const pageData = staticPages[this.endpoint];
      if (pageData) {
        this.pageData = pageData.attributes;
      }
    }));
  }

}
